import { useContext, createContext } from "react";

export const EnumApiContext = createContext({

});

export const useEnumApi = () => useContext(EnumApiContext);